/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconButton } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withRawStyles } from '@bingads-webui-react/with-raw-styles';

import { getCellDeletionButtonDecoratorStyle, getFluentUIStyles } from '../styles/tiles-grid-cell-deletion-button-decorator-style';

const iconProps = { iconName: 'Clear' };

const CellDeletionButtonDecorator = ({
  item, onDelete, children, classes, styles,
}) => {
  //
  const onClick = (event) => {
    if (onDelete) {
      onDelete(item);
    }
    if (event.stopPropagation) { event.stopPropagation(); }
    if (event.preventDefault) { event.preventDefault(); }
  };

  return (
    <>
      {children}
      <div className={classnames(classes.cellDeletionButtonDecorator, 'grid-cell-deletion-button-decorator')}>
        <IconButton
          iconProps={iconProps}
          onClick={onClick}
          ariaLabel="Delete image"
          disabled={false}
          styles={styles.deleteButtonStyles}
        />
      </div>
    </>
  );
};

CellDeletionButtonDecorator.propTypes = {
  item: PropTypes.shape({}).isRequired,
  onDelete: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    cellDeletionButtonDecorator: PropTypes.string,
  }).isRequired,
  styles: PropTypes.shape({
    deleteButtonStyles: PropTypes.shape({}).isRequired,
  }).isRequired,
};

CellDeletionButtonDecorator.defaultProps = {
  onDelete: undefined,
};

export const TilesGridCellDeletionButtonDecorator = withDefaultStyles(
  withRawStyles(CellDeletionButtonDecorator, getFluentUIStyles),
  getCellDeletionButtonDecoratorStyle
);
